module.exports = __webpack_public_path__ + "static/media/icon_confirm.53c04dc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_confirm.png
// module id = 1772
// module chunks = 0 1